import React from 'react'
import { Row } from 'antd'
import Image from 'next/image'
import * as img from 'src/assets/images'
import { useTranslation } from 'next-i18next'
import { LockFilled } from '@ant-design/icons'
import styles from './DevelopersCardAPI.module.scss'
import { DevelopersAPIButtonsContent, CustomText, CustomCol } from 'src/components'
const API_URL = process.env.CT_API

const DevelopersCardAPI: React.FC = () => {
  const { t } = useTranslation()
  const urlWith = API_URL?.startsWith('https://pre') ? '17rem' : '16rem'

  return <>
    <Row>
      <CustomCol>
        <Image
          src={img.ClimatetradeForDevelopers}
          width={150} height={84}
          alt={`dev-api`}
        />
      </CustomCol>
      <CustomCol>
        <div className={styles['conection-container']} style={{ width: urlWith }}>
          <div className={styles['secure-conection-section']}>
            <LockFilled />
            <h4>https://</h4>
            <p>{API_URL?.substring(8, API_URL?.length)}</p>
          </div>
        </div>
      </CustomCol>
    </Row>
    <CustomText label={t('developers.ClimateTradeForDevelopersText1')} className={'mt-5'}/>
    <br /><br />
    <CustomText label={t('developers.ClimateTradeForDevelopersText2')} />
    <DevelopersAPIButtonsContent />
  </>
}

export default DevelopersCardAPI
